import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTION_PAYOUT_ACCOUNT } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import { toast } from "../../components/toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { getLocalizedErrorMessage } from "../../utils/messageHelper";
import i18n from "../../i18n";

// API: POST /api/v1/payment/payout-accounts
// body: { provider_type, label?, payment_method, account_details, is_default }
export const savePayoutAccountReducer = createAsyncThunk(
  ACTION_PAYOUT_ACCOUNT.save_payout_account,
  async (payload, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.payoutAccounts}`,
        { provider_type: "imaging", ...payload },
      );

      if (
        response?.data?.status === true ||
        response?.status === 200 ||
        response?.status === 201
      ) {
        return response.data.data;
      }
      const message = getLocalizedErrorMessage({ response }, i18n);
      toast.error(message);
      return rejectWithValue(message);
    } catch (error) {
      console.error("Error saving payout account:", error);
      const message = getLocalizedErrorMessage(error, i18n);
      toast.error(message);
      return rejectWithValue(message);
    }
  },
);
